<template>
   <b-modal id="modalManageOperations" modal-class="modal-fullscreen" title="Bewerkingen beheren" hide-backdrop
      size="md" scrollable
      @show="focusInput"
      hide-footer>
      <p class="text-muted small">
         Bewerkingen die je hier toevoegt of aanpast, verschijnen in de bewerking-keuzelijst bij een
         recept-ingrediënt (bijv. "gesneden", "geraspt"). Bestaande recepten behouden hun eigen bewerking.
      </p>

      <!-- Nieuwe bewerking toevoegen -->
      <b-form @submit.stop.prevent="addOperation" class="mb-3">
         <b-input-group>
            <b-form-input ref="inputNaam"
               v-model="newOperationName"
               placeholder="Nieuwe bewerking (bijv. gesneden)"
               :state="newOperationValid" />
            <b-input-group-append>
               <b-button type="submit" variant="primary" :disabled="newOperationValid !== true">
                  <b-icon icon="plus" /> Toevoegen
               </b-button>
            </b-input-group-append>
         </b-input-group>
         <b-form-invalid-feedback :state="newOperationValid">{{ newOperationInvalidInfo }}</b-form-invalid-feedback>
      </b-form>

      <!-- Bewerkingen-lijst -->
      <b-list-group flush>
         <b-list-group-item v-for="row in rows" :key="row.id"
            class="d-flex justify-content-between align-items-center py-2 px-1">
            <template v-if="editingId === row.id">
               <b-form-input v-model="editingName" size="sm" class="mr-2"
                  @keydown.enter.prevent="saveEdit" />
               <div class="text-nowrap">
                  <b-button size="sm" variant="success" class="mr-1" @click="saveEdit">
                     <b-icon icon="check" />
                  </b-button>
                  <b-button size="sm" variant="secondary" @click="cancelEdit">
                     <b-icon icon="x" />
                  </b-button>
               </div>
            </template>
            <template v-else>
               <span>{{ row.naam }}
                  <b-badge v-if="!row.local" variant="light" class="ml-1">standaard</b-badge>
               </span>
               <div v-if="row.local" class="text-nowrap">
                  <b-button size="sm" variant="outline-primary" class="mr-1" @click="startEdit(row)">
                     <b-icon icon="pencil" />
                  </b-button>
                  <b-button size="sm" variant="outline-danger" @click="deleteOperation(row)">
                     <b-icon icon="trash" />
                  </b-button>
               </div>
            </template>
         </b-list-group-item>
      </b-list-group>
      <small class="text-muted">{{ rows.length }} bewerkingen</small>
   </b-modal>
</template>
<script>

import db from "../db.js"

export default {
   name: "modal-manage-operations",
   props: ["userID", "operations"],
   data: function() {
      return {
         newOperationName: "",
         newOperationInvalidInfo: "",
         editingId: null,
         editingName: "",
      };
   },
   computed: {
      rows: function() {
         return this.operations.map(o => ({
            id: o.value.id,
            naam: o.value.naam,
            local: o.local === true,
         }))
      },
      newOperationValid: function() {
         if(!this.newOperationName) return null
         const naam = this.newOperationName.trim()
         if(naam == "") return false
         const exists = this.operations.some(o => o.text && o.text.toLowerCase() == naam.toLowerCase())
         return !exists
      },
      now: function() {
         var date = new Date();
         return (
            String (date.getHours()) +
            String (date.getMinutes()) +
            String (date.getSeconds())
         )
      },
   },
   methods: {
      focusInput: function() {
         setTimeout(() => {
            if(this.$refs.inputNaam) this.$refs.inputNaam.focus()
         }, 500)
      },
      operationId: function(naam) {
         return (naam
            .toLowerCase()
            .replace(/[^\w ]+/g, '')
            .replace(/ +/g, '-') + "-" + this.now)
      },
      addOperation: function() {
         const naam = this.newOperationName.trim()
         if(naam == "") {
            this.newOperationInvalidInfo = "Geef een naam op"
            return
         }
         if(this.newOperationValid !== true) {
            this.newOperationInvalidInfo = "Bewerking bestaat al"
            return
         }
         const id = this.operationId(naam)
         db.collection("users").doc(this.userID).collection("operations").doc(id)
            .set({ id: id, naam: naam })
            .then(() => { this.newOperationName = "" })
            .catch(error => console.log(error))
      },
      startEdit: function(row) {
         this.editingId = row.id
         this.editingName = row.naam
      },
      saveEdit: function() {
         const naam = this.editingName.trim()
         if(naam == "") return
         db.collection("users").doc(this.userID).collection("operations").doc(this.editingId)
            .update({ naam: naam })
            .then(() => this.cancelEdit())
            .catch(error => console.log(error))
      },
      cancelEdit: function() {
         this.editingId = null
         this.editingName = ""
      },
      deleteOperation: function(row) {
         if(!confirm(`Weet je zeker dat je bewerking '${row.naam}' wilt verwijderen? Bestaande recepten behouden hun bewerking.`)) return
         db.collection("users").doc(this.userID).collection("operations").doc(row.id)
            .delete()
            .catch(error => console.log(error))
      },
   },
}
</script>
